import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const InfoIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 3, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 11) / 3}
      viewBox="0 0 3 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.27377 3.35742C1.97618 3.35742 2.54755 3.92665 2.54755 4.6312V9.7263C2.54755 10.4287 1.97832 11.0001 1.27377 11.0001C0.571373 11.0001 0 10.4308 0 9.7263V4.6312C0 3.92665 0.571373 3.35742 1.27377 3.35742Z"
        fill="currentColor"
      />
      <path
        d="M1.27377 2.54755C1.97726 2.54755 2.54755 1.97726 2.54755 1.27377C2.54755 0.570288 1.97726 0 1.27377 0C0.570288 0 0 0.570288 0 1.27377C0 1.97726 0.570288 2.54755 1.27377 2.54755Z"
        fill="currentColor"
      />
    </svg>
  )
})

InfoIcon.displayName = 'InfoIcon'
